<template>
  <div class="account-creation-container">
    <AppLogo />
    <PageHeader>Создать аккаунт</PageHeader>
    <form @submit.prevent="saveAccount">
      <InputField type="text" v-model="firstName" placeholder="Имя" />
      <InputField type="text" v-model="lastName" placeholder="Фамилия" />
      <InputField type="password" v-model="password" placeholder="Введите пароль" />
      <div class="checkbox-container">
        <input type="checkbox" v-model="isPrivate" />
        <span class="checkbox-text">Частное лицо</span>
      </div>
      <div>
        <input
            type="text"
            v-model="company"
            placeholder="Компания"
            :disabled="isPrivate"
            :class="{ 'disabled-input': isPrivate }"
        />
      </div>
      <div>
        <select
            v-model="position"
            :disabled="isPrivate"
            :class="{ 'disabled-input': isPrivate }"
        >
          <option value="" disabled selected>Должность</option>
          <option value="manager">Менеджер</option>
          <option value="developer">Разработчик</option>
          <option value="designer">Дизайнер</option>
        </select>
      </div>
      <button type="submit" class="continue-button">Сохранить</button>

      <div class="checkbox-container">
        <input type="checkbox" v-model="subscribeToNews" />
        <span class="checkbox-text">Подписаться на новости рынка и обновления аналитических материалов</span>
      </div>

      <InstructionHelp>
        Нажимая «Сохранить», вы подтверждаете, что согласны на обработку персональных данных и ознакомились с
        <router-link to="/privacy-policy" class="privacy-policy-link">политикой конфиденциальности</router-link>
      </InstructionHelp>
    </form>
  </div>
</template>

<script>
import AppLogo from "@/components/auth/AppLogo.vue";
import PageHeader from "@/components/auth/PageHeader.vue";
import InputField from "@/components/auth/InputField.vue";
import InstructionHelp from "@/components/auth/InstructionHelp.vue";

export default {
  components: {InstructionHelp, InputField, PageHeader, AppLogo},
  data() {
    return {
      firstName: '',
      lastName: '',
      password: '',
      isPrivate: false,
      company: '',
      position: '',
      subscribeToNews: false,
    };
  },
  methods: {
    async saveAccount() {
      try {
        const email = localStorage.getItem('email');
        console.log(email)
        const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: this.firstName,
            user_lastname: this.lastName,
            email: email,
            password: this.password,
            user_type: this.isPrivate ? 'individual' : 'legal_entity',
            company: this.company === '' ? null : this.company,
            position: this.position === '' ? null : this.position,
            is_subscribed: this.subscribeToNews
          })
        });

        if (!response.ok) {
          throw new Error('Ошибка авторизации');
        }

        const data = await response.json();
        const accessToken = data['data']['access_token'];
        const userId = data['data']['user_id'];

        localStorage.setItem('token', accessToken);

        const userResponse = await fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        });

        if (!userResponse.ok) {
          throw new Error('Ошибка получения данных пользователя');
        }

        const userInfo = await userResponse.json();

        this.$store.commit('main/setUserInfo', userInfo.data);

        this.$router.push('/chat');
      } catch (error) {
        console.log(error.message)
      }
    },
  },
};
</script>

<style scoped>
.account-creation-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

input[type="text"],
select {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.continue-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: bold;
}

.continue-button:hover {
  background-color: #333;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  text-align: left;
}

.checkbox-container input {
  margin-right: 10px;
}

.privacy-policy-link {
  text-decoration: underline;
  color: #000;
  cursor: pointer;
}

.disabled-input {
  background-color: #f0f0f0;
  cursor: not-allowed;
}
</style>
